module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "25",
      "height": "25",
      "viewBox": "0 0 25 25",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "25",
      "y": "25",
      "width": "25",
      "height": "25",
      "rx": "12.5",
      "transform": "rotate(180 25 25)",
      "fill": "#DA2226"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "7.1416",
      "y": "8.33203",
      "width": "1.68359",
      "height": "13.4687",
      "rx": "0.848592",
      "transform": "rotate(-45 7.1416 8.33203)",
      "fill": "white"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "7.1416",
      "y": "16.667",
      "width": "13.4687",
      "height": "1.68359",
      "rx": "0.848592",
      "transform": "rotate(-45 7.1416 16.667)",
      "fill": "white"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8bdb5a28", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bdb5a28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/forms/icons/InvalidIcon.vue
// module id = 688
// module chunks = 0